import React from "react";
import _ from "lodash";

import {prepareComponentsWithContractNumber} from "../../../../../../utils"
import PaymentPlansTable from "../../../../../../../../components/ChartsV2/PaymentPlansTable";

export default (props) => {
  const {
    data,
    tradingOptions,
    paymentPlanType,
    skipMPGrouping
  } = props;

  const paymentPlansData = React.useMemo(() => {

    if (!data){
      return []
    }

    if (!data.is_model_portfolio || skipMPGrouping) {
      return _.flatten(data.components.map((component) => {
        const isHeader = !_.isEmpty(component.components)
        return [{
          ...component,
          isHeader,
          tableProps: {
            isHeader // Should be handled inside DashboardTable as header
          }}, ...(component.components || []).map((subComponent) => ({...subComponent, 'isSubComponent': true}))]
      }))
    }

    const result = prepareComponentsWithContractNumber(data, true)

    return _.flatten(_.flatten(
      Object.values(result).map((mpSavingPlan) => [mpSavingPlan, mpSavingPlan.components])))
  }, [skipMPGrouping, data])

  return (
    <div style={{width: '100%', overflowX: 'auto'}}>
      <PaymentPlansTable
        data={paymentPlansData}
        expanded={true}
        tradingOptions={tradingOptions}
        paymentPlanType={paymentPlanType}
      />
    </div>
  );
};

